import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useQuery as useDfcQuery } from 'data-fetching-client';
import { useAssociatedObjectsCardContext } from '../context/AssociatedObjectsCardContext';
import { GET_PROPERTY_DEFINITION } from '../dfc-queries';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { SortAmtAscIcon, SortAmtDescIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AssociatedObjectsCardSort = ({
  sortConfiguration
}) => {
  var _data$propertyDefinit;
  const {
    toObjectTypeId
  } = useAssociatedObjectsCardContext();
  const {
    property,
    direction
  } = sortConfiguration[0];
  const {
    data
  } = useDfcQuery(GET_PROPERTY_DEFINITION, {
    variables: {
      objectTypeId: toObjectTypeId,
      propertyName: property
    }
  });
  const propertyDefinition = data === null || data === void 0 || (_data$propertyDefinit = data.propertyDefinition) === null || _data$propertyDefinit === void 0 ? void 0 : _data$propertyDefinit.property;
  if (!propertyDefinition) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    gap: "100",
    "data-selenium-test": "associated-objects-card-sort",
    "data-test-id": "associated-objects-card-sort",
    marginBlockEnd: "400",
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "cardAssociatedObjects.AssociatedObjectsCardSort.sortedBy",
      options: {
        property: propertyDefinition.label
      }
    }), direction === 'ASC' ? /*#__PURE__*/_jsx(Tooltip, {
      placement: "top",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "cardAssociatedObjects.AssociatedObjectsCardSort.ascDirection"
      }),
      children: /*#__PURE__*/_jsx(SortAmtAscIcon, {})
    }) : /*#__PURE__*/_jsx(Tooltip, {
      placement: "top",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "cardAssociatedObjects.AssociatedObjectsCardSort.descDirection"
      }),
      children: /*#__PURE__*/_jsx(SortAmtDescIcon, {})
    })]
  });
};
AssociatedObjectsCardSort.propTypes = {
  sortConfiguration: PropTypes.arrayOf(PropTypes.shape({
    property: PropTypes.string,
    direction: PropTypes.oneOf(['ASC', 'DESC'])
  }))
};
export default AssociatedObjectsCardSort;